"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUploadModal = createUploadModal;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericFileUploadModal_1 = require("components/modals/GenericFileUploadModal");
var Container_1 = require("components/modals/GenericFileUploadModal/Container");
var actions_1 = require("utils/upload/actions");
var sok_ui_1 = require("@caddigital/sok-ui");
var translate_1 = require("utils/translate");
var Types = require("types");
var createActionsExtractable = Types.extractReturnType(actions_1.createActions);
var mapStateToProps = function (stateFn) {
    return function (state) {
        var selectedLanguage = (0, translate_1.getLanguage)();
        var subState = stateFn(state);
        return {
            location: state.router.location,
            selectedLanguage: selectedLanguage,
            uploadSession: subState.currentUploadStatus.session,
            uploadSettings: state.fileUploadModal.uploadSettings,
            uploadedFiles: subState.uploadedFiles,
            file: state.fileUploadModal.currentUploadStatus.fileId,
            files: subState.files,
            isOpen: subState.modalState.isOpen,
            uploadModalState: subState
        };
    };
};
var mapDispatchToProps = function (actions) { return function (dispatch) { return ({
    toggleModal: function (session) { return (dispatch(actions.toggleModalStatus()),
        dispatch(actions.resetCurrentUploadStatus(session))); },
    startUpload: function (items, parent, unzip, hasDuplicates, fileId, showUploadStatusBar) {
        return dispatch(actions.fileUploadRequestAction(items, parent, unzip, hasDuplicates, fileId, showUploadStatusBar));
    },
    onChange: function (files, location, parent) { return dispatch(actions.setFileUploadFiles(files, location, parent)); },
    clearSelection: function () { return dispatch(actions.setFileUploadFiles([], '#', null)); },
    toggleUnzip: function (unzip) { return dispatch(actions.toggleUnzip(unzip)); },
    toggleReplace: function (replace) {
        return dispatch(actions.toggleReplace(replace));
    }
}); }; };
var statePropsExtractable = Types.extractReturnType(Types.extractReturnType(mapStateToProps));
var dispatchPropsExtractable = Types.extractReturnType(Types.extractReturnType(mapDispatchToProps));
var UploadModalComponent = function (props) {
    var disabled = props.uploadModalState.files.length === 0 ||
        props.uploadModalState.currentUploadStatus.status === 'UPLOADING' ||
        props.uploadModalState.currentUploadStatus.uploadSessionStatus ===
            'CREATING';
    return (React.createElement(GenericFileUploadModal_1.default, { onRequestClose: function () {
            return props.toggleModal(props.uploadModalState.currentUploadStatus.session);
        }, isOpen: props.uploadModalState.modalState.isOpen },
        React.createElement(Container_1.Container, null,
            React.createElement("div", { className: 'description' }, (0, translation_1.getLocalization)(props.descriptionLabel || 'generic/upload/description')),
            React.createElement(sok_ui_1.FileUpload, { accept: props.accept, value: props.uploadModalState.files, multipleFiles: props.multipleFiles || false, uploadedFiles: props.uploadModalState.uploadedFiles, unzip: false, replace: props.uploadSettings.replace, hasDuplicates: props.file !== undefined
                    ? false
                    : props.uploadSettings.hasDuplicates, showZipSelections: false, toggleUnzip: props.toggleUnzip, toggleReplace: props.toggleReplace, onChange: function (f) {
                    return props.onChange(f, props.location.pathname, props.folder);
                }, clearSelection: props.clearSelection }),
            props.uploadModalState.currentUploadStatus.uploadSessionStatus ===
                'CREATING' && (React.createElement("div", null, (0, translation_1.getLocalization)(props.preparingUploadLabel || 'generic/upload/preparingUpload')))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', disabled: disabled, onClick: function () {
                    if (props.folder) {
                        props.startUpload(props.uploadModalState.files, props.folder, props.uploadModalState.uploadSettings.unzip, props.file !== undefined
                            ? false
                            : props.uploadSettings.hasDuplicates, props.fileId, props.uploadModalState.modalState.showUploadStatusBar);
                    }
                } }, (0, translation_1.getLocalization)(props.uploadButtonLabel || 'generic/upload/upload')),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', disabled: disabled, onClick: function () {
                    return props.toggleModal(props.uploadModalState.currentUploadStatus.session);
                } }, (0, translation_1.getLocalization)(props.closeButtonLabel || 'generic/upload/close')))));
};
function createUploadModal(name, stateFn, actions) {
    var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)("".concat(name, "UploadModal")), (0, react_redux_1.connect)(mapStateToProps(stateFn), mapDispatchToProps(actions)), recompose_1.pure);
    return enhance(UploadModalComponent);
}
